import React, { useEffect, useState } from "react";

import BreadcrumbNav from "@components/BreadcrumbNav/BreadcrumbNav";
import HeaderBar from "@components/HeaderBar";
import Navigate from "@components/Navigator";
import ReferFriend from "@components/ReferFriend";
import SideBar from "@components/SideBar";
import TabSide from "@components/TabSide";
import { useLocation, useNavigate } from "react-router-dom";
import * as S from "./style";
import { routes } from "@const/routes";
import useDataSideBar from "src/hooks/useDataSideBar";
import useThemeInitializer from "src/ThemeInitializer";
import { useDispatch } from "react-redux";
import { setTheme } from "@store/themeReducer";
import * as Style from "@views/Pages/Dashboard/style";
import DashboardConstant from "@views/Pages/Dashboard/landing-image.constant";
import RaffleSwiperRender from "@views/Pages/Dashboard/Components/RaffleSwipeRender";
import img from "@assets/img";
import AlertPopup from "@components/AlertPopup";
import { RaffleDataBased } from "@type/Raffle";
import {
  faBars,
  faGaugeHigh,
  faKey,
  faUserFriends,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { EAppAction } from "@store/appReducer";
// import DashboardBox from "@components/DashboardBox";

const HIDE_TABSIDE_PATHS = [
  routes.dashboard,
  routes.raffleResult,
  routes.raffleResultDetail,
];

type ImagesType = {
  logoImage1?: string;
  logoImage2?: string;
  name?: string;
};

const RaffleColors = {
  background: "#FFFFFF",
  title: "#5650DE",
  titleAnother: "#9996B1",
  titleHeading: "#000000",
  titleTurnNext: "#5650DE",
}
const raffleData: RaffleDataBased = {
  raffles: {
    nextRaffle: {
      id: 1,
      raffleId: 18,
      type: "DAILY",
      thumbnailImg: "https://wnnr.fsn1.your-objectstorage.com/3abc6eba-2935-47c9-aec2-f9f22c531fd7.jpg",
      bannerImg: "https://wnnr.fsn1.your-objectstorage.com/3abc6eba-2935-47c9-aec2-f9f22c531fd7.jpg", // placeholder, update as needed
      rn: "",
      favorite: false,
      color: RaffleColors,
      numberOfParticipants: 1,
      startTime: new Date(),
      title: "Demo Raffle",
      status: "ACTIVE",
      expiredDate: new Date("2025-07-20T07:30:00.000Z"),
      category: "General",
      numberOfTurns: 1,
    },
    daily: {
      raffles: [
        {
          id: 1,
          raffleId: 18,
          type: "DAILY",
          thumbnailImg: "https://t4.ftcdn.net/jpg/01/44/93/05/360_F_144930505_9BqvvbP400Iw8whvLhz1AJ2UAxLbMyML.jpg",
          numberOfParticipants: 1,
          startTime: new Date(),
          title: "Demo Raffle 1",
          status: "ACTIVE",
          expiredDate: new Date("2025-07-20T07:30:00.000Z"),
          category: "General",
          numberOfTurns: 1,
          bannerImg: "https://t4.ftcdn.net/jpg/01/44/93/05/360_F_144930505_9BqvvbP400Iw8whvLhz1AJ2UAxLbMyML.jpg",
          rn: "",
          favorite: false,
          color: RaffleColors,
        },
        {
          id: 2,
          raffleId: 17,
          type: "DAILY",
          thumbnailImg: "https://wnnr.fsn1.your-objectstorage.com/609f94f8-73e3-4111-8780-ac6b357e13f0.jpg",
          numberOfParticipants: 1,
          startTime: new Date("2025-07-04T19:30:00.000Z"),
          title: "Demo Raffle 2",
          status: "ACTIVE",
          expiredDate: new Date("2025-07-17T19:30:00.000Z"),
          category: "General",
          numberOfTurns: 1,
          bannerImg: "https://wnnr.fsn1.your-objectstorage.com/609f94f8-73e3-4111-8780-ac6b357e13f0.jpg",
          rn: "",
          favorite: false,
          color: RaffleColors,
        }
      ],
      total: 2
    },
    weekly: {
      raffles: [
        {
          id: 3,
          raffleId: 14,
          type: "WEEKLY",
          thumbnailImg: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUe8M06tHHdaBat3w-zCzeZammcrSbefhSFw&s",
          numberOfParticipants: 1,
          startTime: new Date("2025-06-25T14:30:00.000Z"),
          title: "Demo Weekly Raffle",
          status: "ACTIVE",
          expiredDate: new Date("2025-07-26T14:30:00.000Z"),
          category: "General",
          numberOfTurns: 1,
          bannerImg: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUe8M06tHHdaBat3w-zCzeZammcrSbefhSFw&s",
          rn: "",
          favorite: false,
          color: RaffleColors
        }
      ],
      total: 1
    },
    monthly: {
      // raffles: [
      //   {
      //     id: 6,
      //     raffleId: 6,
      //     type: "MONTHLY",
      //     thumbnailImg: "https://wnnr.fsn1.your-objectstorage.com//wnnr-uat/reward/image/c315685b-47ba-47d0-9412-ab334ec6bd3b.jpg",
      //     numberOfParticipants: 1,
      //     startTime: new Date("2024-12-21T20:00:00.000Z"),
      //     title: "Auric EA",
      //     status: "ACTIVE",
      //     expiredDate: new Date("2024-12-22T20:00:00.000Z"),
      //     category: "General",
      //     numberOfTurns: 1,
      //     bannerImg: "https://wnnr.fsn1.your-objectstorage.com//wnnr-uat/reward/image/c315685b-47ba-47d0-9412-ab334ec6bd3b.jpg",
      //     rn: "",
      //     favorite: false,
      //     color: RaffleColors
      //   },
      //   {
      //     id: 2,
      //     raffleId: 2,
      //     type: "MONTHLY",
      //     thumbnailImg: "https://wnnr.fsn1.your-objectstorage.com//wnnr-uat/reward/image/d518b0b3-767e-44c3-b787-6d40deda0e38.jpg",
      //     numberOfParticipants: 1,
      //     startTime: new Date("2024-12-14T20:00:00.000Z"),
      //     title: "Wonderchef - EA",
      //     status: "ACTIVE",
      //     expiredDate: new Date("2024-12-15T20:00:00.000Z"),
      //     category: "General",
      //     numberOfTurns: 1,
      //     bannerImg: "https://wnnr.fsn1.your-objectstorage.com//wnnr-uat/reward/image/d518b0b3-767e-44c3-b787-6d40deda0e38.jpg",
      //     rn: "",
      //     favorite: false,
      //     color: RaffleColors
      //   }
      // ],
      raffles: [],
      total: 0
    },
    quarterly: {
      raffles: [],
      total: 0
    },
    halfYear: {
      raffles: [],
      total: 0
    },
    annually: {
      raffles: [],
      total: 0
    }
  }
}



export const DashboardPreview = () => {
  const location = useLocation();
  const [navbar, setNavbar] = useState(false);
  const isHideTabside = HIDE_TABSIDE_PATHS.some((pathPattern) => {
    const regex = new RegExp(pathPattern.replace(":id", "\\d+"));
    return regex.test(location.pathname);
  });

  const [images, setImages] = useState<ImagesType>({
    logoImage1: undefined,
    logoImage2: undefined,
    name: undefined,
  });
  const [isOpenCompletedAlert, setIsOpenCompletedAlert] = useState(false);
  const navigate = useNavigate();

  // const nextRaffle = {
  //   title: "Next Game In:",
  //   raffle: raffleData.raffles.nextRaffle,
  //   buttonText: "Join Now!",
  // };

  // const nextBlankRaffle = {
  //   title: "Next Game In:",
  //   blank: "Waiting",
  // };
  const isLoggedIn = useSelector((state: RootState) => state.auth.token);
  const onOpenReferPopup = () => {
    if (!isLoggedIn) {
      navigate("/login");
      return;
    }
    dispatch({
      type: EAppAction.SHOW_REFER_POPUP,
      payload: true,
    });
  };


  const DataSideDashboardBar = [
    {
      id: 1,
      title: "Home",
      link: routes.landing,
      logo: faBars,
    },
    {
      id: 2,
      title: "Dashboard",
      link: routes.dashboardPreview,
      logo: faGaugeHigh,
    },
    {
      id: 3,
      title: "Results",
      link: routes.raffleResult,
      logo: faKey,
    },
    {
      id: 4,
      title: "Refer a friend",
      link: "",
      logo: faUserFriends,
      otherAction: onOpenReferPopup,
    },
  ];

  const { fetchTheme } = useThemeInitializer();
  const dispatch = useDispatch();
  const onFinish = () => {
    setIsOpenCompletedAlert(false);
  };

  useEffect(() => {
    const changeBackGround = () => {
      if (window.scrollY > 20) {
        setNavbar(true);
      } else setNavbar(false);
    };

    window.addEventListener("scroll", changeBackGround);
    return () => {
      window.removeEventListener("scroll", changeBackGround);
    };
  }, [navbar]);

  useEffect(() => {
    fetchTheme('dashboard');
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'SET_THEME') {
        const payload = event.data.payload;

        if (payload.primary) {
          document.body.style.setProperty('--primary-color', payload.primary);
        }
        if (payload.secondary) {
          document.body.style.setProperty('--secondary-color', payload.secondary);
        }
        if (payload.primaryBtn) {
          document.body.style.setProperty('--primary-button-color', payload.primaryBtn);
        }
        if (payload.primaryBtnLabel) {
          document.body.style.setProperty('--primary-button-label-color', payload.primaryBtnLabel);
        }
        if (payload.bg) {
          document.body.style.setProperty('--background-color', payload.bg);
          document.body.style.setProperty('--background-image', 'none');
        }
        if (payload.tertiary) {
          document.body.style.setProperty('--tertiary-color', payload.tertiary);
        }
        if (payload.containerTwoBg) {
          document.body.style.setProperty('--container-two-bg', payload.containerTwoBg);
        }
        if (payload.gradient) {
          document.body.style.setProperty('--gradient-color', payload.gradient);
        }
        if (payload.icons) {
          document.body.style.setProperty('--icon-colors', payload.icons);
        }
        if (payload.error) {
          document.body.style.setProperty('--error-color', payload.error);
        }
        if (payload.success) {
          document.body.style.setProperty('--success-color', payload.success);
        }
        if (payload.info) {
          document.body.style.setProperty('--info-color', payload.info);
        }
        if (payload.iconsBg) {
          document.body.style.setProperty('--icon-bg-color', payload.iconsBg);
        }
        if (payload.placeholder) {
          document.body.style.setProperty('--placeholder-color', payload.placeholder);
        }
        if (payload.inputBorder) {
          document.body.style.setProperty('--input-border-color', payload.inputBorder);
        }
        if (payload.inputText) {
          document.body.style.setProperty('--input-text-color', payload.inputText);
        }
        if (payload.inputBg) {
          document.body.style.setProperty('--input-background-color', payload.inputBg);
        }
        if (payload.focus) {
          document.body.style.setProperty('--focus-color', payload.focus);
        }
        if (payload.hover) {
          document.body.style.setProperty('--hover-color', payload.hover);
        }
        if (payload.disabledBtnBorder) {
          document.body.style.setProperty('--disabled-button-border-color', payload.disabledBtnBorder);
        }
        if (payload.disabledBtnLabel) {
          document.body.style.setProperty('--disabled-button-label-color', payload.disabledBtnLabel);
        }
        if (payload.primaryLabel) {
          document.body.style.setProperty('--primary-label-color', payload.primaryLabel);
        }
        if (payload.secondaryLabel) {
          document.body.style.setProperty('--secondary-label-color', payload.secondaryLabel);
        }
        if (payload.bgType === 'gradient' && payload.bgFrom && payload.bgTo) {
          document.body.style.setProperty('--background-color', `linear-gradient(341.1deg, ${payload.bgFrom} -28.66%, ${payload.bgTo} 87.23%)`);
          document.body.style.setProperty('--background-image', 'none');
        }
        if (payload.tertiaryLabel) {
          document.body.style.setProperty('--tertiary-label-color', payload.tertiaryLabel);
        }
        // Set background image if present
        if (payload.bgImage) {
          document.body.style.setProperty('--background-image', `url(${payload.bgImage})`);
          document.body.style.setProperty('--background-color', 'transparent');
        }
        // Set gradient background if present
        if (payload.gradientType === 'linear' && payload.gradientFrom && payload.gradientTo) {
          document.body.style.setProperty('--background-color', `linear-gradient(341.1deg, ${payload.gradientFrom} -28.66%, ${payload.gradientTo} 87.23%)`);
          document.body.style.setProperty('--background-image', 'none');
        }
        if (payload.subtitle) {
          document.body.style.setProperty('--subtitle-color', payload.subtitle);
        }
        if (payload.activeIconColor) {
          document.body.style.setProperty('--active-icon-color', payload.activeIconColor);
        }
        if (payload.activeIconBgColor) {
          document.body.style.setProperty('--active-icon-bg-color', payload.activeIconBgColor);
        }
        if (payload.activeTextColor) {
          document.body.style.setProperty('--active-text-color', payload.activeTextColor);
        }
        if (payload.raffleBg) {
          document.body.style.setProperty('--raffle-bg-color', payload.raffleBg);
        }
        if (payload.heroBgImage) {
          document.body.style.setProperty('--hero-bg-image', `url(${payload.heroBgImage})`);
        }
        if (payload.heroBgImage === undefined) {
          document.body.style.setProperty('--hero-bg-image', 'none');
        }
        dispatch(setTheme({
          logoImage1: payload.logo1 !== undefined ? payload.logo1 : undefined,
          logoImage2: payload.logo2 !== undefined ? payload.logo2 : undefined,
          name: "Primary",
          logoUrl: payload.logoUrl,
        }));
        setImages({
          logoImage1: payload.logo1 !== undefined ? payload.logo1 : undefined,
          logoImage2: payload.logo2 !== undefined ? payload.logo2 : undefined,
          name: "Primary",
        });
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="dabour-dashboard-header">
      <div className="mobile-hidden">
        <HeaderBar />
      </div>
      <S.ContainerNavigate className={navbar ? "activeBg" : ""}>
        <Navigate />
        <BreadcrumbNav />
        {!isHideTabside && <TabSide tabData={DataSideDashboardBar} />}
      </S.ContainerNavigate>
      <div className="main-body-dashboard">
        <SideBar sideData={DataSideDashboardBar} />
        <div className="main-body-dashboard-right ">
          <div className="hero-section">
            <Style.HeroSectionContainer>
              <div>
                <Style.HeroTitle>play games <br />win goodies, <br />everyday*</Style.HeroTitle>
                <Style.Subtitle>*Terms and Condition apply</Style.Subtitle>
              </div>
              <div className="hero-image">
                <img alt="hero" style={{ width: 140 }} src={images.logoImage1 ?? DashboardConstant.Robot} />
              </div>
            </Style.HeroSectionContainer>
          </div>
          {/* <Style.Top>
            {raffleData.raffles.nextRaffle ? (
              <DashboardBox {...nextRaffle} />
            ) : (
              <DashboardBox {...nextBlankRaffle} />
            )}
          </Style.Top> */}
          <div className="dashboard-container">
            <div className="raffle-container">
              <RaffleSwiperRender raffleData={raffleData} />
            </div>
            <div className="wheel-game-container">
              <h1>{images.name ?? "Primary"} Insta-Win</h1>
              <img src={images.logoImage2 ?? img.wheelGame} alt="Wheel Game" className="wheel-game-image" />
            </div>
          </div>
          <AlertPopup
            isOpen={isOpenCompletedAlert}
            header="Congratulation"
            title={
              <>
                Thank you for your participation!
                <br />
                You have 1 Free Ticket!
              </>
            }
            icon={img.StarIcon}
            leftButton={{
              title: "View Your Tickets",
              onClick: () => navigate(routes.ticket),
            }}
            onDismiss={onFinish}
          />

        </div>
      </div>
      <ReferFriend />
    </div>
  );
};

export const useFetchImages = () => {
  const [images, setImages] = useState({
    logoImage1: undefined,
    logoImage2: undefined,
    name: "Primary"
  });

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'SET_THEME') {
        const payload = event.data.payload;
        setImages({
          logoImage1: payload.logo1 !== undefined ? payload.logo1 : undefined,
          logoImage2: payload.logo2 !== undefined ? payload.logo2 : undefined,
          name: "Primary"
        });
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return images;
}
